<template>
    <div>

        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data">
            <input type="hidden" name="_token" :value="csrf">
            <input name="skillsPerson[person_id]" type="hidden" v-model="this.person_id">
            <div class="form-group">
                <select v-model="selectedSkill" class="form-control">
                    <option disabled value="">{{ __('misc.select') }}</option>
                    <option v-for="(skill,index) in this.skills" :value="index"> {{skill}}</option>
                </select>
            </div>
            <div class="form-group">
                <select v-model="selectedLevel" class="form-control">
                    <option disabled value="">{{ __('misc.select') }}</option>
                    <option v-for="(level,index) in levels" :value="index"> {{level}}</option>
                </select>
            </div>
            <div class="form-buttons clear">
                <button @click="addRowSkill" class="btn btn--green" type="button"><i class="fa fa-plus-circle"></i> @lang("views.People.add_skill")</button>
            </div>
            <div class="clear has-padding-top has-padding-bottom"></div>
            <div class="single--item has-border-bottom has-padding-bottom">
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-12">
                        <div class="single--item-button"></div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-12">
                        <div class="single--item-info">
                            <h6>Skill</h6>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-12">
                        <div class="single--item-info">
                            <h6>Level</h6>
                        </div>
                    </div>
                    <!--
                    <div class="col-lg-2 col-md-2 col-12">
                        <div class="single--item-info">
                            <h6>Note</h6>
                        </div>
                    </div>
                    -->
                </div>
            </div>
            <div class="single--item has-border-bottom has-padding-bottom" >
                <div class="row"  v-for="(row,index) in skillsGet" style="padding: 5px">
                    <div class="col-lg-2 col-md-2 col-12">
                        <div class="single--item-button">
                            <button type="button" class="btn btn--only-icon-rounded btn--danger" @click="rmRowSkill(index)" >
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-12">
                        <div class="single--item-info">
                            {{row.skill}}
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-12">
                        <div class="single--item-info">
                            <select :name="'peopleSkill['+index+']'" v-model="row.level_id" class="form-control" style="width: 100%;">
                                <option disabled value="">{{ __('misc.select') }}</option>
                                <option v-for="(level,index) in levels" :value="index"> {{level}}</option>
                            </select>
                        </div>
                    </div>

                    <!--
                    <div class="col-lg-2 col-md-2 col-12">
                        <div class="single--item-info">
                            <a href="#" :onClick="'app.__vue__.$refs.vue_popup.toggle(\'Note\', \''+row.note_url+'\' )'"  class="btn">Edit</a>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="form-buttons clear">
                <button type="submit" class="btn">{{ __('misc.update') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        methods: {
            getUrl(){
                return '';
            },
            rmRowSkill(index){
                //Delete element
                Vue.delete(this.skillsGet,index);
            },
            addRowSkill(){
                console.log(this.selectedSkill,this.selectedLevel);
                //Check if
                if ( this.selectedSkill ==='' || this.selectedLevel===''){
                    alert("Non puoi lasciare campi vuoti");
                    return;
                }
                let postData = {
                    person_id : this.person_id,
                    skill_level_id          : this.selectedLevel,
                    skill_id                : this.selectedSkill,
                };
                axios.put('/people-skill-widget/store', postData)
                    .then(response => {
                        location.reload();
                    });

                //Clean variables

            },
        },
        mounted() {

            axios.get(this.url)
            .then((response) => {
                this.skillsGet  = response.data.skills;
                this.action     = response.data.action;
            });

        },
        data()  {
            return {
                action : "",
                selectedSkill : "",
                selectedLevel : "",
                skillsGet : null,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        props: {
            url: {
                type: String,
                required: true
            },
            person_id: {
                type: Number,
                required: true
            },
            skills: {
                type: Object,
                required: true
            },
            levels: {
                type: Object,
                required: true
            },


        },


    }
</script>

